import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import { Title } from 'components/utils';
import { Button, Input, InputNumber, Form, Drawer } from 'antd';

import { useRecoilState } from 'recoil';
import { tokenState } from 'global/state';


export const DrawerForm = (props) => {

  return (
    <Drawer
      title="Update Token Details"
      placement="right"
      closable={ true }
      onClose={ props.handleClose }
      visible={ true }
      width={ 300 }
      maskClosable={ false }
    >
      <DrawerContaier>
        <TokenForm onSubmit={ props.handleClose } />
      </DrawerContaier>
    </Drawer>
  )

}

const DrawerContaier = styled.div`
  .form-container {
    margin-top: 0 !important;
    border: none !important;
    padding: 0 !important;
  }
`;




const TokenForm = (props) => {
  const [ form ] = Form.useForm();
  const [ token, setToken ] = useRecoilState(tokenState);

  const handleFormSubmit = (values) => {
    setToken({ ...values, completed: true });
    if ( props.onSubmit ) {
      setTimeout( () => {
        props.onSubmit();
      }, 1500 );
    }
  }

  return (
    <Container className="form-container">

      <Form
        form={form}
        layout="vertical"
        onFinish={ handleFormSubmit }
        initialValues={token}
      >
        <Form.Item
          label="Token Name"
          name="name"
          tooltip="Please Enter Your Token Name, Ex: Binance Smart Chain Token"
          rules={[{ required: true, message: 'Please Enter Your Token Name' }]}
        >
          <Input placeholder="Token Name" />
        </Form.Item>

        <Form.Item
          label="Token Symbol"
          name="symbol"
          tooltip="Please Enter Your Token Symbol, Ex: BSC"
          rules={[{ required: true, message: 'Please Enter Your Token Symbol' }]}
        >
          <Input placeholder="Token Symbol" />
        </Form.Item>

        <Form.Item
          label="Total Decimals"
          name="decimal"
          tooltip="Enter How Many Decimals Your Token Will Have, Ex: 18"
          rules={[{ required: true, message: 'Please Enter How Many Decimals Your Token Will Have' }]}
        >
          <InputNumber min={1} max={50} style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          label="Total Supply"
          name="supply"
          tooltip="Please Enter Your Tokens Total Supply, Ex: 10000000000 (without decimals)"
          rules={[{ required: true, message: 'Please Enter Your Tokens Total Supply' }]}
        >
          <InputNumber min={1} style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <Button type="primary" htmlType="submit" block>Submit and Verify</Button>
        </Form.Item>
      </Form>

    </Container>
  )
}

export default TokenForm;



const Container = styled.div`
  margin-top: 20px;
  border: 1px solid #434b5a;
  padding: 30px;
  border-radius: 5px;
  background: #fff;
  font-family: 'Balsamiq Sans', cursive;

  p {
    font-size: 16px;
    line-height: 20px;
    font-family: 'Balsamiq Sans', cursive;
    color: #2196f3;
  }

  label, input { cursor: pointer; }
  label { font-weight: 700; }
`;
